import React from 'react'
import 'src/branding/redis/survey-banner.css'

export const RedisSurveyBanner: React.FC = () => {
  return (
    <div id="top-banner">
      <div className="banner-content">
        <div className="status-dot"></div>
        <div className="banner-text-group">
          <div className="banner-message">Help us make Redis University better.</div>
          <a className="banner-link-wrapper" href="https://forms.gle/cB5JqV8wFYb6WbtM7" target="_self">
            <span className="banner-link">Take our annual survey</span>
            <span className="banner-link-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 13">
                <path
                  fill="currentColor"
                  fill-rule="nonzero"
                  d="m21.84 12.09 6.046-6.045L21.84 0l-.796.79 4.696 4.689H0v1.133h25.74l-4.696 4.69z"
                ></path>
              </svg>
            </span>
          </a>
        </div>
      </div>
    </div>
  )
}
